import { Button } from "antd";
import Style from "../output.module.css";
import { submitScenarioType } from "../../../@types/user";
import React, { Fragment, memo, useEffect, useState } from "react";
import NumberFormat from "../../../utils/NumberFormat";
import GraphScreen from "./GraphScreen";
import WrapperOutput from "./WrapperOutput";
import { Checkbox, Modal, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import ModalBox from "../../modal";
import ScrollerWrapper from "../../scrollerWrapper";
import { CloseOutlined, RightOutlined } from "@ant-design/icons";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BarChartIcon from '@mui/icons-material/BarChart';
import CompareIcon from '@mui/icons-material/Compare';
import Flynaut from "../../branding/Flynaut";
import PrintBtn from "../../PrintBtn";
import AnalysisScreen from "./AnalysisScreen";
import CurrencyIconRenderer from "../../CurrencyIconRendered";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import LoanScreen from "./LoanScreen";
import SingleLoanScreen from "./SingleLoanScreen";
import LoanNameFormatter from "../../../utils/LoanNameFormatter";
import ComparedScreen from "./ComparedScreen";
import FSLoader from "../../FSLoader";
import TableScreen from "./TableScreen";
import { filteredResulttype, filteredResulttypeOb, Payload, resultType } from "../types";


type compareListType = {
    scenario:{name:string,key:string}[],
    base : {name:string,key:string}[],
    comparable : {name:string,key:string}[]
}

type outputScreenPropType={
    result:resultType,
    compareJobs:boolean,
    myCurrency:string,
    setResult:(res:resultType)=> void,
    submitableScenario:submitScenarioType[],
    payload:Payload,
    setPayload:(val:Payload)=> void,
    loading:boolean,
    reCalc:(val:Payload)=> void
}

const OutputScreen = ({result,compareJobs,myCurrency,setResult,submitableScenario,payload,setPayload,loading,reCalc}:outputScreenPropType)=>{

    const activeTabJobs = useSelector((state: RootState) => state.calculator.activeScenarioJobs); 
    const [myresult,setMyresult] = useState<filteredResulttype[]>([]);
    const [compared,setCompared] = useState<filteredResulttype[]>([]);
    const [prep,setPrep] = useState<{
        name:string,
        data:{
            name:string,
            value:string[]
        }[],
        servicableYear:number,
        yearsRemaining:number
    }[][]>([]);
    const [mapper,setMapper] = useState<{name:string,data:string[]}[]>([]);
    const [showGraph,setShowGraph] = useState(false);
    const [showTable,setShowTable] = useState(false);
    const [comparePopup,setComparePopup] = useState(false);
    const [showAnalysis,setShowAnalysis] = useState(false);
    const [showAmmort,setShowAmmort] = useState(false);
    const [compareList,setCompareList] = useState<compareListType>({
        scenario:[],
        base : [],
        comparable : []
    });
    const [compareEnabled,setCompareEnabled] = useState(false);
    const [error,setError] = useState("");

    const [selectedLoan,setSelectedLoan] = useState("");
    const [selectedLoanResult,setSelectedLoanResult] = useState<resultType>([]);

    const [selectedDataForCmp,setSelectedDataForCmp] = useState<number[]>([]);


    const onDragEnd = (result:any)=>{
        
        if (!result.destination) {
            return;
        }

        if(result.destination.droppableId === "base" && compareList.base.length === 1){
            return;
        }

        const source = result.source.droppableId === "scenarios" ? [...compareList.scenario || []] : result.source.droppableId === "base" ? [...compareList.base || []] : [...compareList.comparable || []];
        const desti = result.destination.droppableId === "scenarios" ? [...compareList.scenario  || []] : result.destination.droppableId === "base" ? [...compareList.base  || []] : [...compareList.comparable || []];

        if(JSON.stringify(source) === JSON.stringify(desti)){
            const [removed] = source.splice(result.source.index, 1);
            source.splice(result.destination.index, 0, removed);

            (result.source.droppableId === "scenarios") &&
            setCompareList(prev=> ({...prev,scenario: source}));
            
            (result.source.droppableId === "base") &&
            setCompareList(prev=> ({...prev,base: source}));
            
            (result.source.droppableId === "comparable") &&
            setCompareList(prev=> ({...prev,comparable: source}));
        }
        else{

            const [removed] = source.splice(result.source.index, 1);
            desti.splice(result.destination.index, 0, removed);

            (result.source.droppableId === "scenarios") &&
            setCompareList(prev=> ({...prev,scenario: source}));
            
            (result.source.droppableId === "base") &&
            setCompareList(prev=> ({...prev,base: source}));
            
            (result.source.droppableId === "comparable") &&
            setCompareList(prev=> ({...prev,comparable: source}));

            (result.destination.droppableId === "scenarios") &&
            setCompareList(prev=> ({...prev,scenario: desti}));
            
            (result.destination.droppableId === "base") &&
            setCompareList(prev=> ({...prev,base: desti}));
            
            (result.destination.droppableId === "comparable") &&
            setCompareList(prev=> ({...prev,comparable: desti}));
            
        }
        

        
        
    };

    const getFormatedYears = (years:number)=>{
        let x= years.toFixed(2).toString();
        let y = x.split(".");


        return { years:parseInt(y[0]), months:y.length > 1 ? parseFloat(y[1])/100 : 0};
    }

    useEffect(()=>{

        setMyresult([result.map(elem=> ({
            name:elem.name,
            cashFlow:elem.output.cashflowTable,
            output:{jobNames:elem.output.result.jobNames,data:elem.output.result.data.map(el=> ({...el,data:el.data.map(ell=> ({...ell,value:ell.value.map((arval)=> parseFloat( arval ? arval.toFixed(2) : "0" ) ) }))}))} }) )]);

    },[result]);

    useEffect(()=>{

        window.scrollTo(0,0);       

        let mapper = result[0].output.result.data.map(elem=> ({name:elem.name,data:elem.data.map(el=> el.name)}) );
        setMapper(mapper);
    },[])

 

    // Setting cashflow editable data
    useEffect(()=>{

        if(myresult.length < 1) return;

        console.log("Myresult from output",myresult);
        console.log("result from output",result);

        let localPrep : {
            name:string,
            data:{
                name:string,
                value:string[]
            }[],
            servicableYear:number,
            yearsRemaining:number
        }[][] = [];

        myresult.forEach((elem,index) => {

            let x:{
                name:string,
                data:{name:string,value:string[]}[],
                servicableYear:number,
                yearsRemaining:number,
            }[] = [];


            elem.forEach((element,ind) => {

                let inflation = element.cashFlow[element.cashFlow.length-1].inflation;
                let tax_rate = element.cashFlow[element.cashFlow.length-1].tax;
                let wacc = element.cashFlow[element.cashFlow.length-1].wacc;
                let volume = element.cashFlow[element.cashFlow.length-1].volume;
                let month = element.cashFlow[element.cashFlow.length-1].tables.sv.length;

                let fay = getFormatedYears( element.cashFlow[element.cashFlow.length-1].greatestTimeFrame );
                let fry = getFormatedYears( element.cashFlow[element.cashFlow.length-1].years_remaining );

                let sy = fay.years;
                let ry = fry.years;

                if(fay.months !== 0) sy++;
                if(fry.months !== 0) ry++;
    
                let Volume:string[] = Array.from({length:month}).map((elem,ind)=> ind === 0 || ind > sy ? "0" : (volume ? volume.toString() : "0") );
                let Inflation:string[] = Array.from({length:month}).map((elem,ind)=> ind <= 1 || ind > sy ? "0" : (inflation ? inflation.toString() : "0") );
                let Lta:string[] = Array.from({length:month}).map((elem,ind)=> ("0" ) );
                let Tax:string[] = Array.from({length:month}).map((elem,ind)=> (ind > sy ? "0" : (tax_rate ? tax_rate.toString() : "0") ) );
                let Wacc:string[] = Array.from({length:month}).map((elem,ind)=> (ind > sy ? "0" : (wacc ? wacc.toString() : "0" ) ) );
    
                x = [
                    ...x,
                    {
                        name:element.name,
                        data:[
                            {
                                name:'Volume',
                                value:Volume
                            },
                            {
                                name:'Inflation',
                                value:Inflation
                            },
                            {
                                name:'Long term agreement',
                                value:Lta
                            },
                            {
                                name:'Tax Rate',
                                value:Tax
                            },
                            {
                                name:'WACC',
                                value:Wacc
                            }
                        ],
                        servicableYear: sy,
                        yearsRemaining : ry
                    }
                ]
            
            });
            
            localPrep.push(x);
        });
        
        setPrep(localPrep);

    },[myresult]);

    useEffect(()=>{

        if(!selectedDataForCmp) return;

        let data:compareListType = {...compareList};
        
        if(selectedDataForCmp.length === 1){ //Spread jobs of the selected Scenario
            data = {
                scenario: myresult[0][selectedDataForCmp[0]].output.jobNames.filter(el=> el.type !== "extra").map((elem,ind)=> ({key:`${ind}`,name:elem.name})), 
                base:[], 
                comparable:[]
            }
        }
        else{ // Spread all Scenarios
            data = {
                scenario: myresult[0]?.filter((el,ind)=> selectedDataForCmp.indexOf(ind) !== -1).map((elem,index)=> ({key:`${index}`,name:elem.name})),
                base:[], 
                comparable:[]
            }
        }

        console.log("data list of compare", data);

        setCompareList(data);

    },[selectedDataForCmp])

    const initCompareScenarios = ()=>{
       
        if(compareList.base.length === 0){
            return setError("Base scenario can't be empty !");
        }
        if(compareList.comparable.length === 0){
            return setError("Comparable scenario can't be empty !");
        }

        compare();
    }

    const subTwoArray = (arr:number[][])=>{

        let louter = arr.length;
        let larr = arr.map(elem=> elem.length).reduce((a,b)=> a > b ? a : b);
    
        let newArr:number[] = [];
    
        for(let i=0; i< louter; i++){
            for(let j=0; j<larr; j++){
                if(newArr[j]){
                    newArr[j] -= (arr[i][j] || 0);
                }
                else{
                    newArr[j] = (arr[i][j] || 0);
                }
            }
        }
    
        return newArr;
    
    }

    const addTwoArray = (arr:number[][])=>{

        let louter = arr.length;
        let larr = arr.map(elem=> elem.length).reduce((a,b)=> a > b ? a : b);
    
        let newArr:number[] = [];
    
        for(let i=0; i< louter; i++){
            for(let j=0; j<larr; j++){
                if(newArr[j]){
                    newArr[j] -= (arr[i][j] || 0);
                }
                else{
                    newArr[j] = (arr[i][j] || 0);
                }
            }
        }
    
        return newArr;
    
    }

    const compare = ()=>{   
        
        let x:filteredResulttype[] = [];

        compareList.comparable.forEach(element => {

            let first:filteredResulttypeOb;
            let second:filteredResulttypeOb;
            
            if(selectedDataForCmp.length === 1){

                first = myresult[0][selectedDataForCmp[0]];
                first = {
                    ...first,
                    output:{
                        ...first.output,
                        jobNames:[first.output.jobNames[parseInt(compareList.base[0].key)]],
                        data:first.output.data.map((elem,index)=> ({
                            ...elem, 
                            data:elem.data.map((el,ind)=> ({
                                ...el,
                                value: [el.value[parseInt(compareList.base[0].key)]] 
                            }))
                        }))
                    },
                    cashFlow: [first.cashFlow[parseInt(compareList.base[0].key)]]
                };

                second = myresult[0][selectedDataForCmp[0]];
                second = {
                    ...second,
                    output:{
                        ...second.output,
                        jobNames:[second.output.jobNames[parseInt(element.key)]],
                        data:second.output.data.map((elem,index)=> ({
                            ...elem, 
                            data:elem.data.map((el,ind)=> ({
                                ...el,
                                value: [el.value[parseInt(element.key)]] 
                            }))
                        }))
                    },
                    cashFlow: [second.cashFlow[parseInt(element.key)]]
                };

            }
            else{
                first = {
                    ...myresult[0][parseInt(compareList.base[0].key)],
                    cashFlow: [myresult[0][parseInt(compareList.base[0].key)].cashFlow[myresult[0][parseInt(compareList.base[0].key)].cashFlow.length - 1]],
                };
                second = {
                    ...myresult[0][parseInt(element.key)],
                    cashFlow: [myresult[0][parseInt(element.key)].cashFlow[myresult[0][parseInt(element.key)].cashFlow.length - 1]],
                };
            }

            let res = {
                ...first, 
                name:selectedDataForCmp.length !== 1 ? `${first.name} - ${second.name}` : `${first.name}`,
                output:{
                    jobNames:[{type:"extra",name:selectedDataForCmp.length !== 1 ? `Delta` : `${first.output.jobNames[0].name} - ${second.output.jobNames[0].name}`}],
                    data:first.output.data.map((elem,index)=> ({...elem, data:elem.data.map((el,ind)=> {
    
                        return {...el,value: [ parseFloat( ((el.value[el.value.length-1] || 0 ) - (second?.output?.data[index].data[ind].value[ second?.output?.data[index].data[ind].value.length - 1 ] || 0)).toFixed(2) ) ] }
                        
                    })}) )
                },
                cashFlow: [
                { 
                    atrosRate : first.cashFlow.map(el=> el.atrosRate).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.atrosRate).reduce((a,b)=> a+b),
                    ,
                    cavities : first.cashFlow.map(el=> el.cavities).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.cavities).reduce((a,b)=> a+b),
                    ,
                    enterpriseProfitLoss: first.cashFlow.map(el=> el.enterpriseProfitLoss).reduce((a,b)=> a+b) - second.cashFlow.map(el=> el.enterpriseProfitLoss).reduce((a,b)=> a+b),
                    greatestTimeFrame: first.cashFlow.map(el=> el.greatestTimeFrame).reduce((a,b)=> a+b) > second.cashFlow.map(el=> el.greatestTimeFrame).reduce((a,b)=> a+b) ?
                    first.cashFlow.map(el=> el.greatestTimeFrame).reduce((a,b)=> a+b)
                    :
                    second.cashFlow.map(el=> el.greatestTimeFrame).reduce((a,b)=> a+b),
                    greatestTotalTimeFrame:first.cashFlow.map(el=> el.greatestTotalTimeFrame).reduce((a,b)=> a+b) > second.cashFlow.map(el=> el.greatestTotalTimeFrame).reduce((a,b)=> a+b) ?
                    first.cashFlow.map(el=> el.greatestTotalTimeFrame).reduce((a,b)=> a+b)
                    :
                    second.cashFlow.map(el=> el.greatestTotalTimeFrame).reduce((a,b)=> a+b),
                    inflation: first.cashFlow.map(el=> el.inflation).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.inflation).reduce((a,b)=> a+b),
                    ,
                    irrRate:first.cashFlow.map(el=> el.irrRate).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.irrRate).reduce((a,b)=> a+b),
                    ,
                    oh_inflation: first.cashFlow.map(el=> el.oh_inflation).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.oh_inflation).reduce((a,b)=> a+b),
                    ,
                    abc_oh_inflation: first.cashFlow.map(el=> el.abc_oh_inflation!).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.abc_oh_inflation!).reduce((a,b)=> a+b),
                    ,
                    ot_above_x: first.cashFlow.map(el=> el.ot_above_x).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.ot_above_x).reduce((a,b)=> a+b),
                    ,
                    ot_above_y: first.cashFlow.map(el=> el.ot_above_y).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.ot_above_y).reduce((a,b)=> a+b),
                    ,
                    scrapRate: first.cashFlow.map(el=> el.scrapRate).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.scrapRate).reduce((a,b)=> a+b),
                    ,
                    scrapSales: first.cashFlow.map(el=> el.scrapSales).reduce((a,b)=> a+b) 
                    // - second.cashFlow.map(el=> el.scrapSales).reduce((a,b)=> a+b),
                    ,
                    sellPrice: first.cashFlow.map(el=> el.sellPrice).reduce((a,b)=> a+b) - second.cashFlow.map(el=> el.sellPrice).reduce((a,b)=> a+b),
                    tax: first.cashFlow.map(el=> el.tax).reduce((a,b)=> a+b)/first.cashFlow.length,
                    totalCost: first.cashFlow.map(el=> el.totalCost).reduce((a,b)=> a+b) - second.cashFlow.map(el=> el.totalCost).reduce((a,b)=> a+b),
                    totalInv: first.cashFlow.map(el=> el.totalInv).reduce((a,b)=> a+b) - second.cashFlow.map(el=> el.totalInv).reduce((a,b)=> a+b),
                    volume: first.cashFlow.map(el=> el.volume).reduce((a,b)=> a+b) - second.cashFlow.map(el=> el.volume).reduce((a,b)=> a+b),
                    wacc: first.cashFlow.map(el=> el.wacc).reduce((a,b)=> a+b)/first.cashFlow.length,
                    years_remaining: first.cashFlow.map(el=> el.years_remaining).reduce((a,b)=> a+b) > second.cashFlow.map(el=> el.years_remaining).reduce((a,b)=> a+b) ?
                    first.cashFlow.map(el=> el.years_remaining).reduce((a,b)=> a+b)
                    :
                    second.cashFlow.map(el=> el.years_remaining).reduce((a,b)=> a+b),
                    tables: {
                        bv: subTwoArray([addTwoArray(first.cashFlow.map((el,ind)=> el.tables.bv )),addTwoArray(second.cashFlow.map((el,ind)=> el.tables.bv ))]),
                        ds: subTwoArray([addTwoArray(first.cashFlow.map((el,ind)=> el.tables.ds )),addTwoArray(second.cashFlow.map((el,ind)=> el.tables.ds ))]),
                        sv: subTwoArray([addTwoArray(first.cashFlow.map((el,ind)=> el.tables.sv )),addTwoArray(second.cashFlow.map((el,ind)=> el.tables.sv ))])
                    }
                    }
                ]
            
            }

            if(selectedDataForCmp.length !== 1){
                first = {
                    ...first,
                    output:{
                        ...first.output,
                        jobNames:first.output.jobNames.filter(elem=> elem.type === "extra"),
                        data:first.output.data.map((elem,index)=> ({
                            ...elem, 
                            data:elem.data.map((el,ind)=> ({
                                ...el,value: [el.value[el.value.length - 1]] 
                            }))
                        }))
                    }
                };
                second = {
                    ...second,
                    output:{
                        ...second.output,
                        jobNames:second.output.jobNames.filter(elem=> elem.type === "extra"),
                        data:second.output.data.map((elem,index)=> ({
                            ...elem, 
                            data:elem.data.map((el,ind)=> ({
                                ...el,value: [el.value[el.value.length - 1]] 
                            }))
                        }))
                    }
                };
            }

            x.push([{...first},{...second},{...res}]);
        });
        

        setComparePopup(false);
        setCompared(x);
        setCompareEnabled(true);
    }

    const isSalesdiv = (outerInd:number, innerInd:number)=>{



    }
    return(
        <div className="outputScreen">
        {
            (!showGraph && !showTable && !compareEnabled && !showAnalysis && !showAmmort) &&
            <WrapperOutput
            name={["Home","Output"]}
            onBackPress={()=> setResult([])}
            leftButtons={[
               <PrintBtn />,
               <Button
               type="text" 
               className={`${Style.rtBtn}`}
               onClick={()=> setShowAmmort(true) }
               >
                   <MonetizationOnIcon />
                   Loans
               </Button>,
            //    <Button
            //     type="text" 
            //     className={`${Style.rtBtn}`}
            //     onClick={()=> setShowAnalysis(true) }
            //     >
            //         <MonetizationOnIcon />
            //         SP Analysis
            //     </Button>,
                <Button
                type="text" 
                className={`${Style.rtBtn}`}
                onClick={()=> setShowTable(true) }
                >
                    <MonetizationOnIcon />
                    Cash Flows
                </Button>,
                <Button 
                type="text" 
                className={`${Style.rtBtn}`}
                onClick={()=> setShowGraph(true) }
                >
                    <BarChartIcon />
                    Graph
                </Button>,
                <Button
                type="text" 
                className={`${Style.rtBtn}`}
                onClick={()=> setComparePopup(true) }
                >
                    <CompareIcon />
                    Compare
                </Button>
            ]}
            >
                <div className={`${Style.resHolder} printable`}>
                {
                    loading &&
                    <FSLoader>
                        <p style={{
                            fontSize:"42px"
                        }}>Calculating...</p>
                    </FSLoader>
                }
                {
                    myresult.map((aelem,aindex)=>(
                        <ScrollerWrapper
                        contentCntStyle={{
                            gap:"15px"
                        }}
                        >
                    <>

                    {
                        mapper.map((outerElem,outerInd)=>(
                            <Table key={outerInd} sx={{
                                borderCollapse: 'separate',
                                borderSpacing: '5px', // horizontal and vertical gap
                                background:"white"
                                }}>
                                <TableHead> 
                                    <TableRow>
                                        <TableCell 
                                        className="outputTableHeaderCell"
                                        align="center" 
                                        colSpan={aelem.map((el)=> el.output.jobNames?.length || 0).reduce((a,b)=> a+b) + 1}>
                                            <div
                                            style={{
                                                minHeight:"35px",
                                                display:"flex",
                                                alignItems:"center",
                                                justifyContent:"center"
                                            }}
                                            >
                                                {outerElem.name}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="outputTableNameCell">

                                        </TableCell>
                                        {
                                            aelem?.map((el,ind)=>(
                                                <TableCell 
                                                className="outputTableSceCell"
                                                align="center" 
                                                key={`scename${ind}`} 
                                                colSpan={(el.output.jobNames?.length || 1)}>
                                                    {el.name}
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="outputTableNameCell">

                                        </TableCell>
                                        {
                                            aelem?.map((el,ind)=>(
                                                <Fragment key={`scename${ind}`}>
                                                    {
                                                        el.output.jobNames.map((elj,inj)=>(
                                                            <TableCell 
                                                            className="outputTableJobCell"
                                                            align="center" 
                                                            key={`scename${ind}${inj}`} 
                                                            colSpan={1}>
                                                            {elj.name}
                                                            </TableCell>
                                                        ))
                                                    }
                                                </Fragment>
                                            
                                            ))
                                        }
                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {
                                        outerElem.data.map((field,fieldInd)=>(
                                            ((outerInd === 0 && fieldInd === 3) || (outerInd === 0 && fieldInd === 4)) ?
                                            <></>
                                            :
                                            <React.Fragment key={`field${fieldInd}`}>
                                                <TableRow>
                                                    <TableCell 
                                                    align="left" 
                                                    className="outputTableNameCell"
                                                    >
                                                        <div style={{width:outerInd === 0 ? "210px" : outerInd === 1 ? "225px" : "210px"}}>
                                                        {field}
                                                        </div>
                                                    </TableCell>
                                                    {
                                                        aelem.map((sce,sceind)=>(
                                                            sce.output.data[outerInd].data[fieldInd].value.map((cell,cellInd)=>(
                                                                <TableCell 
                                                                align="center" 
                                                                key={`cellValue${cellInd}`}
                                                                className={
                                                                    `
                                                                    outputTableDataCell
                                                                    ${
                                                                        (outerInd === 0 && fieldInd === 1) &&
                                                                        ((
                                                                            (sce.output.data[outerInd].data[4].value[cellInd] != 0 && sce.output.data[outerInd].data[fieldInd].value[cellInd] < sce.output.data[outerInd].data[4].value[cellInd]) || 
                                                                            (sce.output.data[outerInd].data[3].value[cellInd] != 0 && sce.output.data[outerInd].data[fieldInd].value[cellInd] > sce.output.data[outerInd].data[3].value[cellInd] )
                                                                        )
                                                                            ?
                                                                            "danger"
                                                                            :
                                                                            "green"
                                                                        )
                                                                    }
                                                                    ${
                                                                        (
                                                                        (outerInd === 0 && fieldInd ===10) ||
                                                                        (outerInd === 0 && fieldInd ===11) ||
                                                                        (outerInd === 0 && fieldInd ===12) ||
                                                                        (outerInd === 0 && fieldInd ===13) ||
                                                                        (outerInd === 0 && fieldInd ===22) ||
                                                                        (outerInd === 0 && fieldInd ===23) ||
                                                                        // (outerInd === 0 && innerInd ===16) ||
                                                                        // (outerInd === 0 && innerInd ===17) ||
                                                                        // (outerInd === 0 && innerInd ===21) ||
                                                                        (outerInd === 1 && fieldInd ===8) ||
                                                                        (outerInd === 1 && fieldInd ===9) ||
                                                                        (outerInd === 1 && fieldInd ===10) ||
                                                                        (outerInd === 1 && fieldInd ===11) ||
                                                                        (outerInd === 1 && fieldInd ===12) ||
                                                                        (outerInd === 1 && fieldInd ===13) ||
                                                      
                                                                        (outerInd === 2 && fieldInd ===6) ||
                                                                        (outerInd === 2 && fieldInd ===7) ||
                                                                        (outerInd === 2 && fieldInd ===8) ||
                                                                        (outerInd === 2 && fieldInd ===9) ||
                                                                        (outerInd === 2 && fieldInd ===10) ||
                                                                        (outerInd === 2 && fieldInd ===11) 
                                                                    ) &&
                                                                    (
                                                                        sce.output.data[outerInd].data[fieldInd].value[cellInd] < 0 ? "danger" : "green"
                                                                    )
                                                                    }
                                                                    ${
                                                                        (outerInd === 0 && (fieldInd === 27 || fieldInd === 28 || fieldInd === 29 || fieldInd === 30 )) && 
                                                                        ((((sce.output.data[0].data[fieldInd].value[cellInd]/sce.output.data[0].data[1].value[cellInd]) * 100 > ( (sce.cashFlow.map(elem=> elem.atrosRate)[cellInd] || 0) ) ) ) ?
                                                                        "green"
                                                                        :
                                                                        "danger")
                                                                    }
                                                                    ${
                                                                        ((outerInd === 1 ) && (fieldInd === 14 || fieldInd === 15 || fieldInd === 16 || fieldInd === 17)) && 
                                                                        ((((sce.output.data[0].data[fieldInd+13].value[cellInd]/sce.output.data[0].data[1].value[cellInd]) * 100 > ( (sce.cashFlow.map(elem=> elem.atrosRate)[cellInd] || 0) ) ) ) ?
                                                                        "green"
                                                                        :
                                                                        "danger")
                                                                    }
                                                                    ${
                                                                        ((outerInd === 2) && (fieldInd === 12 || fieldInd === 13 || fieldInd === 14 || fieldInd === 15)) && 
                                                                        ((((sce.output.data[0].data[fieldInd+15].value[cellInd]/sce.output.data[0].data[1].value[cellInd]) * 100 > ( (sce.cashFlow.map(elem=> elem.atrosRate)[cellInd] || 0) ) ) ) ?
                                                                        "green"
                                                                        :
                                                                        "danger")
                                                                    }
                                                                    ${
                                                                        (outerInd === 2 && fieldInd ===16) &&
                                                                        (sce.output.data[outerInd].data[fieldInd].value[cellInd] < ( (sce.cashFlow.map(elem=> elem.irrRate)[cellInd] || 0) )  ? "danger" : sce.output.data[outerInd].data[fieldInd].value[cellInd] != 11011 && "green")
                                                                    
                                                                    }
                                                                    ${
                                                                        ((outerInd === 3 && (fieldInd ===0 || fieldInd ===1 || fieldInd ===2 || fieldInd ===3))) &&
                                                                        (
                                                                            (
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] > ( (sce.cashFlow.map(elem=> elem.ot_above_x)[cellInd] || 0) )  && 
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] <= ( (sce.cashFlow.map(elem=> elem.ot_above_y)[cellInd] || 0) ) 
                                                                            )? "danger" :
                                                                            (
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] > ( (sce.cashFlow.map(elem=> elem.ot_above_y)[cellInd] || 0))  && 
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] <= 8500
                                                                            ) ? "superdanger" : 
                                                                            (
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] > 8500 && "notpossiblevalue"
                                                                            )
                                                                        )
                                                                    }
                                                                    `
                                                                }
                                                                >
                                                                    
                                                                    <div style={{
                                                                        display:"flex",
                                                                        alignItems:"center",
                                                                        justifyContent:"center",
                                                                        gap:"2px",
                                                                        // minHeight:"55px"
                                                                    }}>
                                                                        {
                                                                        
                                                                            sce.output.data[outerInd].data[fieldInd].type === "currency" &&
                                                                            <CurrencyIconRenderer type={myCurrency} className="currencyIcon" />
                                                      
                                                                        }
                                                                        {
                                                                            (outerInd === 2 && fieldInd === 16) ?
                                                                            (sce.output.data[outerInd].data[fieldInd].value[cellInd] === 11011) &&
                                                                            "NA"
                                                                            :
                                                                            ((
                                                                                outerInd === 3 && (fieldInd === 2 || fieldInd === 3) && 
                                                                                (sce.output.data[outerInd].data[fieldInd].value.length === 1 ||
                                                                                    sce.output.data[outerInd].data[fieldInd].value.length -1 !== cellInd)
                                                                                
                                                                            )) ?
                                                                            <>
                                                                            {
                                                                                (outerInd === 3 && fieldInd === 2 ) &&
                                                                                <input
                                                                                style={{
                                                                                    width:"100px",
                                                                                    height:"45px",
                                                                                    background:"white",
                                                                                    border:"none",
                                                                                    outline:"none",
                                                                                    textAlign:"center",
                                                                                    borderRadius:"5px"
                                                                                }}
                                                                                value={
                                                                                    myCurrency === "INR" ?
                                                                                    NumberFormat.toINDstandard((payload[sceind]?.data[cellInd]?.data?.abc_continuous_hours?.toString()))
                                                                                    :
                                                                                    NumberFormat.toUSstandard((payload[sceind]?.data[cellInd]?.data?.abc_continuous_hours?.toString()))
                                                                                }
                                                                                onChange={(e)=>{
                                                                                    let x = [...payload];
                                                                                    x[sceind].data[cellInd].data.abc_continuous_hours = parseFloat(NumberFormat.toNumber(e.target.value));
                                                                                    setPayload(x);
                                                                                    reCalc(x);
                                                                                }} 
                                                                                />
                                                                            }
                                                                            {
                                                                                (outerInd === 3 && fieldInd === 3 ) &&
                                                                                <input
                                                                                style={{
                                                                                    width:"100px",
                                                                                    height:"45px",
                                                                                    background:"white",
                                                                                    border:"none",
                                                                                    outline:"none",
                                                                                    textAlign:"center",
                                                                                    borderRadius:"5px"
                                                                                }}
                                                                                value={
                                                                                    myCurrency === "INR" ?
                                                                                    NumberFormat.toINDstandard((payload[sceind]?.data[cellInd]?.data?.abc_non_continuous_hours?.toString()))
                                                                                    :
                                                                                    NumberFormat.toUSstandard((payload[sceind]?.data[cellInd]?.data?.abc_non_continuous_hours?.toString()))
                                                                                }
                                                                                onChange={(e)=>{
                                                                                    let x = [...payload];
                                                                                    x[sceind].data[cellInd].data.abc_non_continuous_hours = parseFloat(NumberFormat.toNumber(e.target.value));
                                                                                    setPayload(x);
                                                                                    reCalc(x);
                                                                                }} 
                                                                                />
                                                                              

                                                                            }
                                                                               
                                                                            </>
                                                                            :
                                                                            myCurrency === "INR" ?
                                                                                NumberFormat.toINDstandard((cell).toFixed(2))
                                                                                :
                                                                                NumberFormat.toUSstandard((cell).toFixed(2))
                                                                            
                                                                        }
                                                                        {
                                                                             (
                                                                                sce.output.data[outerInd].data[fieldInd].type === "perc" && 
                                                                                sce.output.data[outerInd].data[fieldInd].value[cellInd] != 11011 
                                                                            ) &&
                                                                            <span>
                                                                                %
                                                                            </span>
                                                                          
                                                                        }
                                                                    </div>
                                                                </TableCell>
                                                            ))
                                                        ))
                                                    }   
                                                </TableRow>
                                            {
                                                (
                                                    (outerInd === 0 && fieldInd === 2) ||
                                                    (outerInd === 0 && fieldInd === 9) ||
                                                    (outerInd === 0 && fieldInd === 11) ||
                                                    (outerInd === 0 && fieldInd === 13) ||
                                                    (outerInd === 0 && fieldInd === 17) ||
                                                    (outerInd === 0 && fieldInd === 19) ||
                                                    (outerInd === 0 && fieldInd === 21) ||
                                                    (outerInd === 0 && fieldInd === 23) ||
                                                    (outerInd === 0 && fieldInd === 26) ||
                                                    (outerInd === 0 && fieldInd === 28) ||
    
                                                    ((outerInd === 1) && fieldInd === 2) ||
                                                    ((outerInd === 1) && fieldInd === 7) ||
                                                    ((outerInd === 1) && fieldInd === 9) ||
                                                    ((outerInd === 1) && fieldInd === 11) ||
                                                    ((outerInd === 1) && fieldInd === 13) ||
                                                    ((outerInd === 1) && fieldInd === 15) ||

                                                    ((outerInd === 2) && fieldInd === 0) ||
                                                    ((outerInd === 2) && fieldInd === 5) ||
                                                    ((outerInd === 2) && fieldInd === 7) ||
                                                    ((outerInd === 2) && fieldInd === 9) ||
                                                    ((outerInd === 2) && fieldInd === 11) ||
                                                    ((outerInd === 2) && fieldInd === 13) ||
    
                                                    (outerInd === 3 && fieldInd === 1) ||
                                                    (outerInd === 3 && fieldInd === 3) ||
                                                    (outerInd === 3 && fieldInd === 4) ||
                                                    (outerInd === 3 && fieldInd === 6) ||
                                                    (outerInd === 3 && fieldInd === 10) ||
                                                    (outerInd === 3 && fieldInd === 11)
                                                ) &&
                                                <TableRow 
                                                sx={{
                                                    height:"25px"
                                                    }}>
                                                        <TableCell 
                                                        sx={{
                                                          
                                                        }}
                                                        colSpan={aelem.map((el)=> el.output.jobNames?.length || 0).reduce((a,b)=> a+b) + 1}
                                                        >
                                                            <hr style={{
                                                                border: "none",
                                                                borderTop: "2px dashed gainsboro"
                                                            }} />
                                                        </TableCell>
                                                    
                                                </TableRow>
                                            }
                                            </React.Fragment>
                                            
                                        ))
                                    }

                                </TableBody>

                            </Table>
                        ))
                    }

                    </>
                </ScrollerWrapper>
                    ))
                }
                
                </div>
            </WrapperOutput>
        }
        {
            
            (showGraph && !compareEnabled) &&
            <WrapperOutput
            onBackPress={()=> setShowGraph(false) }
            name={["Home","Output","Graphs"]}
            leftButtons={[
                <PrintBtn />
            ]}
            >
                <GraphScreen 
                mapper={mapper.map((aelem,aind)=> ({ ...aelem, data: aelem.data.filter((belem,bind)=> (aind === 0 && (bind === 1 || bind === 2) ) ? false : true ) }) )}
                myresult={ myresult.map((elem,ind)=>  elem.map((el,ii)=> ({...el,output: {jobNames:el.output.jobNames,data: el.output.data.map((inner,innerInd)=> ( {...inner,data:inner.data.filter((sin,sinInd)=> (innerInd === 0 && (sinInd === 1 || sinInd === 2)) ? false : true )} ) ) } }) ) ) }
                />
            </WrapperOutput>
            
            
        }
        {
            (showTable && !compareEnabled && !showAnalysis) &&
            <WrapperOutput
            onBackPress={()=> setShowTable(false) }
            name={["Home","Output","Cash Flows"]}
            leftButtons={[
                <Button
                type="text" 
                className={`${Style.rtBtn}`}
                onClick={()=> setShowAnalysis(true) }
                >
                    <MonetizationOnIcon />
                    SP Analysis
                </Button>,
                <PrintBtn />
            ]}
            >
                <TableScreen
                    myresult={myresult}
                    compareJobs={compareJobs}
                    prep={prep}
                    setPrep={setPrep}
                    submitableScenario={submitableScenario}
                    payload={payload}
                />
            </WrapperOutput>
        }
        {
            (showAnalysis && !compareEnabled) &&
            <WrapperOutput
            onBackPress={()=> setShowAnalysis(false) }
            name={["Home","Output","SP Analysis"]}
            leftButtons={[
                <PrintBtn />
            ]}
            >
    
                <AnalysisScreen
                myresult={myresult[0]}
                />
            </WrapperOutput>
        }
        {
            ((showAmmort && !selectedLoan) && !compareEnabled) &&
            <WrapperOutput
            onBackPress={()=> setShowAmmort(false) }
            name={["Home","Output","Loans"]}
            leftButtons={[
         
            ]}
            >
                
                <LoanScreen 
                result={result} 
                myCurrency={myCurrency} 
                selectedLoan={selectedLoan} 
                setSelectedLoan={setSelectedLoan} 
                setSelectedLoanResult={setSelectedLoanResult} 
                compareJobs={compareJobs}
                />
                
            </WrapperOutput>
        }
        {
            ((showAmmort && selectedLoan) && !compareEnabled) &&
            <WrapperOutput
            onBackPress={()=> setSelectedLoan("") }
            name={["Home","Output","Loans",LoanNameFormatter.format(selectedLoan)]}
            leftButtons={[
         
            ]}
            >
                
                <SingleLoanScreen 
                result={selectedLoanResult} 
                myCurrency={myCurrency} 
                selectedLoan={selectedLoan}  
                compareJobs={compareJobs}
                />
                
            </WrapperOutput>
        }
        {
            compareEnabled &&             
            <ComparedScreen 
            result={compared}
            setCompareEnabled={setCompareEnabled}
            myCurrency={myCurrency}
            mapper={mapper}
            submitableScenario={submitableScenario}
            />
        }
        {
            comparePopup &&
            <Modal
            className="modal"
            open={comparePopup}
            onClose={()=> {
                setComparePopup(false);
            }}
            >
    
            <div className="modalPopUp" style={{maxWidth:"600px"}}>

                <CloseOutlined
                className="popupClose" 
                onClick={()=> {
                    setComparePopup(false);
                }}
                />
                <Flynaut />

                <div style={{
                    margin:"20px 0",
                    paddingBottom:"15px",
                    borderBottom:"1px dashed #ccc",
                    width:"100%",
                    justifyContent:"center",
                    }}>

                    {
                        myresult[0]?.map((elem,ind)=>(
                            <div 
                            key={`sceSelec${ind}`}
                            style={{
                                display:"inline-flex",
                                alignItems:"center",
                                margin:"0 5px"
                            }}>
                            <Checkbox 
                            id={`sceSelec${ind}`}
                            checked={ selectedDataForCmp.indexOf(ind) !== -1 ? true : false }
                            onChange={(e)=>{
                                if(e.target.checked && selectedDataForCmp.indexOf(ind) === -1){
                                    setSelectedDataForCmp((prev)=> [...prev,ind]);

                                }
                                else{
                                    let x = [...selectedDataForCmp];
                                    x.splice(x.indexOf(ind),1);
                                    setSelectedDataForCmp(x);
                                }
                            }}
                            />
                            <label 
                            htmlFor={`sceSelec${ind}`} 
                            style={{fontSize:"14px"}}
                            >{elem.name}</label>
                            </div>
                        ))
                    }
                    
                    
                    
                </div>

                <DragDropContext onDragEnd={onDragEnd}>

                <div className={Style.cmpListCnt}>
                        <div className={Style.cmpListTop}>
                        
                            <div className={Style.listCnt}>
                                {
                                    selectedDataForCmp.length > 1 &&
                                    <p>All Selected Scenario</p>
                                }
                                {
                                    selectedDataForCmp.length === 1 &&
                                    <p>All the jobs of <b>{myresult[0][selectedDataForCmp[0]]?.name}</b></p>
                                }
                                {
                                    selectedDataForCmp.length === 0 &&
                                    <p>Compare Options</p>
                                }
                                <Droppable droppableId="scenarios" type="scenarios">
                                    {(provided, snapshot) => {
                                    return (
                                        <div
                                        className={Style.mainListCnt}
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        >
                                        {
                                            compareList.scenario?.map((elem,ind)=>(
                                                <Draggable key={elem.key} draggableId={`${elem.key}`} index={ind}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                        <div
                                                        className={Style.listTileCnt}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                
                                                            <div className={Style.listTile}>
                                                            {elem.name}
                                                            </div>
                                                            
                                                        
                                                        </div>
                                                        );
                                                    }}
                                                    </Draggable>
                                            ))
                                        }
                                        {provided.placeholder}
                                        </div>
                                    );
                                    }}
                                </Droppable>
                            </div>
                    

                        </div>
                        <div className={Style.cmpListBot}>

                            <div className={Style.listCnt}>

                                <p>Base Scenario</p>
                                <Droppable  droppableId="base" type="scenarios">
                                    {(provided, snapshot) => {
                                    return (
                                        <div
                                        className={Style.mainListCnt}
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        >
                                        {
                                            compareList.base?.map((elem,ind)=>(
                                                <Draggable key={elem.key} draggableId={`${elem.key}`} index={ind}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                        <div
                                                        className={Style.listTileCnt}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                        
                                                        <div className={Style.listTile}>
                                                                {elem.name}
                                                            </div>
                                                        
                                                        </div>
                                                        );
                                                    }}
                                                    </Draggable>
                                            ))
                                        }
                                        {provided.placeholder}
                                        </div>
                                    );
                                    }}
                                </Droppable>

                            </div>
                            <div className={Style.listCnt}>
                                <p>Comparable Scenario</p>
                                <Droppable droppableId="comparable" type="scenarios">
                                    {(provided, snapshot) => {
                                    return (
                                        <div
                                        className={Style.mainListCnt}
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        >
                                        {
                                            compareList.comparable?.map((elem,ind)=>(
                                                <Draggable key={elem.key} draggableId={`${elem.key}`} index={ind}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                        <div
                                                        className={Style.listTileCnt}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                        
                                                            <div className={Style.listTile}>
                                                                {elem.name}
                                                            </div>
                                                        
                                                        </div>
                                                        );
                                                    }}
                                                    </Draggable>
                                            ))
                                        }
                                        {provided.placeholder}
                                        </div>
                                    );
                                    }}
                                </Droppable>
                            </div>

                        </div>
                    </div>
                </DragDropContext>
                
                <div className="mpuBot">

                <Button className="histbtn-blue" type="text" onClick={initCompareScenarios}>
                    Compare <RightOutlined />
                </Button>

                </div>
            </div>      
            </Modal>
        }
        {
            error &&
            <Modal
            open={error ? true : false}
            onClose={()=> {
                setError("");
            }}
            >
                <ModalBox
                open={error ? true : false}
                onClose={()=> setError("") }
                header="Restricted !"
                message={error} 
                onOk={()=>{
                    setError("")
                }}
                />
            </Modal>
        }
        </div>
    )
}

export default memo(OutputScreen);